import Alpine from "alpinejs";
import goToURL from "../modules/helpers/goToURL";

Alpine.magic("goToURL", () => (url) => {
    return goToURL(url);
});